const ID_SPACE: number = (() => {
    const storedValue = localStorage.getItem("ID_SPACE");
    if(storedValue){
      const parseValue  = Number.parseInt(storedValue, 10);
      return parseValue;
    }
    return 76
}) ();

const LOCALE = "fr-FR";
    
export { ID_SPACE, LOCALE };